<template>
  <div class="usia-cards">
    <div class="container">
      <div class="row">

        <div class="col-lg-4 col-sm-6">
          <div class="us-card">
            <img :src="row.image1" class="img-fluid us-card-view" alt="">
            <div class="us-card-header mb-4" :style="'backgroundColor:'+row.bgColor1">
              <div class="us-card-line" :style="'backgroundColor:'+row.lineColor1"></div>
              <div class="title" v-html="row.title1"></div>
            </div>
            <div class="text mb-2" v-html="row.body1"></div>
            <router-link v-if="row.button1" :to="row.redirect1" class="us-btn" v-html="row.button1"></router-link>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="us-card">
            <img :src="row.image2" class="img-fluid us-card-view" alt="">
            <div class="us-card-header mb-4" :style="'backgroundColor:'+row.bgColor2">
              <div class="us-card-line" :style="'backgroundColor:'+row.lineColor2"></div>
              <div class="title" v-html="row.title2"></div>
            </div>
            <div class="text mb-2" v-html="row.body2"></div>
            <router-link v-if="row.button2" :to="row.redirect2" class="us-btn" v-html="row.button2"></router-link>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6">
          <div class="us-card">
            <img :src="row.image3" class="img-fluid us-card-view" alt="">
            <div class="us-card-header mb-4" :style="'backgroundColor:'+row.bgColor3">
              <div class="us-card-line" :style="'backgroundColor:'+row.lineColor3"></div>
              <div class="title" v-html="row.title3"></div>
            </div>
            <div class="text mb-2" v-html="row.body3"></div>
            <router-link v-if="row.button3" :to="row.redirect3" class="us-btn" v-html="row.button3"></router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.usia-cards {
  padding-top: 30px; 
  padding-bottom: 60px; 
}
.us-card {
  margin-bottom: 30px;
}
.us-card-view {
  height: 145px;
  width: 100%;
  object-fit: cover;
}
.us-card-header {
  padding: 26px 20px;
}
.us-card-line {
  height: 4px;
  width: 70px;
  margin-bottom: 17px;
}
.title {
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  line-height: 1;
}
.text {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.3;
}
.us-btn {
  color: #241EB4;
  font-weight: 600;
  font-size: 15px
}
.us-btn:hover {
  opacity: 0.6;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
    
}

@media (max-width: 767.98px) {
  
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .title {
    font-size: 25px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {

}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {

}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section1",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>

